import { render, staticRenderFns } from "./VaccinePricing.vue?vue&type=template&id=5fd1c3da&scoped=true&"
import script from "./VaccinePricing.vue?vue&type=script&lang=js&"
export * from "./VaccinePricing.vue?vue&type=script&lang=js&"
import style0 from "./VaccinePricing.vue?vue&type=style&index=0&id=5fd1c3da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd1c3da",
  null
  
)

export default component.exports